export const FEATURE_FLAGS = {
  /** Gates the resolution time metric filter in analytics, allowing filtering conversations by resolution duration. */
  RESOLUTION_TIME: 'resolution_time',
  /** Controls visibility and access to the Processes section in the navigation sidebar and processes-related pages. */
  PROCESSES: 'processes',
  /** Enables a Processes tab in the message meta panel to display process activities and events associated with messages. */
  MESSAGE_FEED_PROCESS_ACTIVITIES: 'message_feed_process_activities',
  /** Gates the linked models configuration section in app side panels for selecting which models trigger custom actions. */
  APP_LINKED_MODELS: 'app_linked_models',
  /** Enables multi-label classification mode allowing models to predict multiple tags for a single input. */
  MULTI_LABEL: 'multi_label',
  /** Gates the AI-assisted custom action builder that uses a chat interface instead of auto-generation for app creation. */
  CUSTOM_STEPS_CURSOR_MODE: 'custom_steps_cursor_mode',
  /** Enables next-generation extraction model creation and management with PDF-based entity generation capabilities. */
  NEXT_GEN_MODELS: 'next_gen_models',
  /** Gates the next-generation classification model creation flow with updated API and UI. */
  NEXT_GEN_CLASSIFICATION: 'next_gen_classification',
  /** Gates the /flows route architecture for automations; when enabled, redirects from /automations to /flows. */
  AUTOMATIONS_V12: 'automations_v12',
  /** Controls the new FlowPredicate UI component for flow condition editing instead of the legacy ConditionInput component. */
  NEW_FLOW_CONDITIONS: 'new_flow_conditions',
  /** Enables the ability to create and manage test sets for extraction model predictions via the entity model panel. */
  EXPERIMENTAL_ENTITY_TEST_SETS: 'experimental_entity_test_sets',
  /** Gates the process version filter that allows users to view and select different versions of a draft process. */
  PROCESS_VERSIONS: 'process_versions',
  /** Enables the Topic Discovery feature for automated topic analysis and tag creation from message data in analytics. */
  TOPIC_DISCOVERY: 'topic_discovery',
  /** Controls the display of message count indicators next to subject lines in the message feed list view. */
  MESSAGE_COUNT_IN_FEED: 'message_count_in_feed',
  /** When enabled, hides the Processes beta feature from the side navigation, meta panel, and process pages. */
  DISABLE_PROCESSES_BETA: 'disable_processes_beta',
  /** Enables the animated flow trail on process variant paths in the process viewer. */
  PROCESS_MINING_ANIMATION: 'process_mining_animation',
  /** Enables internal notes on messages: add and view notes in meta panel, message card, reading pane, and Outlook add-in. */
  INTERNAL_NOTES: 'internal_notes',
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;
